/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import InputPassword from '../../components/FormControl/input/InputPassword';
import { useSnackbar } from 'notistack';
import Template from '../../components/layout/Public';
import Grid from '@mui/material/Grid';
import { useParams } from 'react-router-dom';
import { Alert } from '@mui/material';
import { handlerErrorV2 } from '../../utils/errors';
import { updatePassword, getAccessToken } from '../../services/auth/auth.service';
import { validate } from '../../utils';
import isEmpty from 'lodash/isEmpty';
import ButtonStartIcon from '../../components/button/ButtonStartIcon';

const NewPassword = ({ title, type }) => {
  const navigate = useNavigate();
  const { token } = useParams();

  const { enqueueSnackbar } = useSnackbar();

  const [form, setInputForm] = useState({ newPasswordConfirmation: '', newPassword: '' });
  const [errors, setInputErrors] = useState({ newPasswordConfirmation: null, newPassword: null });
  const [loading, setLoading] = useState(false);
  const [invalidToken, setInvalidToken] = useState(false);

  const onChange = (name, value) => {
    setInputForm({ ...form, [name]: value });
    setInputErrors({ ...errors, [name]: null });
  };

  const onCheckToken = useCallback(async () => {
    setLoading(true);
    try {
      const result = await getAccessToken(token, { type });
      if (!result.data && result.error) {
        setInvalidToken(true);
        setInputErrors({ message: result.error.message || 'Something went wrong. Please try again.' });
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      setInputErrors({ message });
      setInvalidToken(true);
    } finally {
      setLoading(false);
    }
  }, [token]);

  const onSubmit = async (e) => {
    e.preventDefault();
    const fieldRules = {
      newPassword: 'required|password',
      newPasswordConfirmation: `required|match:${form.newPassword}`
    };

    const errors = validate(fieldRules, form);
    if (!isEmpty(errors)) {
      setInputErrors(errors);
      return;
    }

    try {
      setLoading(true);
      const result = await updatePassword(token, { ...form, type });
      if (!result.data && result.error) {
        setInputErrors({ message: result.error.message || 'Something went wrong. Please try again.' });
      } else {
        enqueueSnackbar('Password changed successfully', { variant: 'success' });
        navigate('/login');
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      setInputErrors({ message });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    onCheckToken();
  }, [onCheckToken]);

  return (
    <Template title={title}>
      {invalidToken ? (
        <>
          <Grid item xs={12}>
            {errors.message && <Alert severity='error'>{errors.message}</Alert>}
          </Grid>
          <Grid item xs={12}>
            <Link to='/login' className='text-right-login border p-2 rounded-lg bg-loading clickable'> 
              Back to login
            </Link>
          </Grid>
        </>
      ) : (
        <Grid item xs={12} container spacing={2}>
          <Grid item xs={12}>
            <InputPassword
              id='profile-new-password'
              variant='outlined'
              label='Enter your new password'
              value={form?.newPassword}
              error={errors?.newPassword}
              helperText={errors?.newPassword}
              onChange={(e) => onChange('newPassword', e.target.value)}
              fullWidth={true}
            />
          </Grid>
          <Grid item xs={12}>
            <InputPassword
              id='profile-confirm-password'
              variant='outlined'
              label='Confirm your new password'
              value={form?.newPasswordConfirmation}
              error={errors?.newPasswordConfirmation}
              helperText={errors?.newPasswordConfirmation}
              onChange={(e) => onChange('newPasswordConfirmation', e.target.value)}
              fullWidth={true}
            />
          </Grid>
          <Grid item xs={12}>
            {errors.message && <Alert severity='error'>{errors.message}</Alert>}
          </Grid>
          <Grid item xs={12}>
            <ButtonStartIcon
              size='medium'
              loading={loading}
              className='login-button'
              onClick={onSubmit}
              startIcon={['fal', 'check']}
            >
              {type}
            </ButtonStartIcon>
          </Grid>
        </Grid>
      )}
    </Template>
  );
};

export default NewPassword;
